import React from 'react';

const BOLT_ICON_URL = 'https://assets.thdstatic.com/images/v1/bolt.svg';

export const BoltIcon = () => (
  <img
    src={BOLT_ICON_URL}
    alt="bolt"
    width="16"
    height="16"
    data-testid="bolt-icon"
  />
);

BoltIcon.displayName = 'BoltIcon';
